import {hasProperty, setProperty} from 'dot-prop'
import {cloneDeep} from 'lodash-es'

import {isObject} from './utils'

const LOCALSTORAGE_ITEM = 'asiagoit-forms'

export function saveUserData(newDataProxy, schemaFields = []) {
	const data = loadUserData()
	data.date_updated = Date.now()
	const newData = cloneDeep(newDataProxy)

	// remove data that shouldn't be remembered
	for (const field of schemaFields) {
		if (field.app_props?.remember_value !== false) {
			continue
		}

		setProperty(newData, field.path, null)

		let i = 1
		while (
			field.path.includes('[0]') &&
			hasProperty(newData, field.path.replace('[0]', `[${i}]`))
		) {
			setProperty(newData, field.path.replace('[0]', `[${i}]`), null)
			i++
		}
	}

	// parse data
	for (const [field, value] of Object.entries(newData)) {
		if (Array.isArray(value) && value.every(isObject)) {
			// handle arrays (container/multiple)

			// delete old array fields (rooms[3].xxx, 4th room might not exist anymore)
			for (const key of Object.keys(data.fields)) {
				if (key.startsWith(`${field}[`)) {
					delete data.fields[key]
				}
			}

			// insert the new array fields
			value.forEach((child, index) => {
				for (const [childField, childValue] of Object.entries(child)) {
					data.fields[`${field}[${index}].${childField}`] = childValue
				}
			})
		} else {
			data.fields[field] = value
		}
	}

	localStorage.setItem(LOCALSTORAGE_ITEM, JSON.stringify(data))
}

export function loadUserData() {
	const defaultData = {
		date_updated: 0,
		fields: {},
	}

	const data = JSON.parse(localStorage.getItem(LOCALSTORAGE_ITEM))

	return data?.date_updated >= Date.now() - 60 * 60 * 24 * 7 * 1000 ? data : defaultData
}

export function resetUserData() {
	localStorage.removeItem(LOCALSTORAGE_ITEM)
}
